import { getCompanyInfo } from "./getCompanyInfo";

/** 开启点击行为日志上报 */
export const isEnableClickLog = () => ['localhost', 'app.cartsee.com'].includes(window.location.hostname);

/** 开启新服务 */
export const isEnableNewService = () => true;

export const isEnableWheelCouponSetting = () => {
  return true;
}

export const isEnablePopupCover = () => {
  return true;
};

export const isEnablePrivacySetting = () => {
  return true;
}

export const isEnableCombinedDiscountCode = () => {
  return true;
}

export const isEnablePopSetting = () => {
  return true;
};

export const isEnableAuth = () => {
  return [30, 328, 565, 621, 1227, 1533, 2224, 2346, 2347, 2348, 2349, 2350, 2351, 907, 2523, 2733, 1738, 3140, 3048, 1756, 1893, 3221, 1289, 1292, 1400, 1401, 1455, 1456, 1482, 1483, 1484, 1485, 2005, 3351, 3356, 2667].includes(getCompanyInfo().id as number);
};

/** 仅限新订阅用户发放券包 */
export const ONLY_NEW_USER_TPLID = window.location.hostname === 'app.cartsee.com' ? ['126'] : ['153'];

/** 大转盘模板 */
export const BIG_WHEEL_TPLID = ['1', '18'];

/** 多步骤采集模板 */
export const MULTI_STEP_TPLID = ['19', '20', '40', '41'];

export const DISABLE_SMS_SUBSCRIPTION_TPLID= [...ONLY_NEW_USER_TPLID, ...BIG_WHEEL_TPLID, ...MULTI_STEP_TPLID];

export const DISABLE_CUSTOM_STEP_TPLID = ['1', '18', '19', '20', '21', '22', '23', '24', '25', '26', '40', '41', '97', '116', '117', '118', '126'];

export const SMB_GRAY_SHOPIFY_LIST = [1791,1790,1827,1828,1860,2671,2512,3001,3029,2626,2670,2111,2696,3203,2541,2373,12,2584,718,1501,1650,1507,1509,1917,1864,2040,1499,1834,1500,1620,1816,1817,1845,2751,2221,2079,1974,2205,1505,2527,1516,1515,2275,2423,2114,2738,2525,2453,1582,1333,2802,1767,2084,2764,1354,1534,56,2742,1840,2801,3193,29,1863,1819,1833,2339,3014,1508,1588,1532,1818,1043,2071,2693,2380,2231,2544,2509,2604,2741,2710,2740,2955,3112,3115,3127,3139,3149,3164,2080,2528,2496,2357,2039,2567,2247,2341,1960,1992,2038,2099,2410,2031,2036,2013,2020,2009,2032,2033,2035,2019,2024,2025,2001,61,1626,2255,2568,2615,31,2744,2734,2705,2735,2745,2704,2297,1372,1570,2202,1926,2985,3225,2861,3361,3315,2953,3399,3420,3433,3495];
// shopline shopify shoplazza SMB店铺id灰度列
export const SMB_GRAY_SHOLINE_LIST = [2260,2863,2862,2860,2606,2562,2502,2559,1730,1452,1632,1853,1856,1877,2815,2258,2245,1748,71,2237,3059,2378,2382,2822,2534,2002,3223,2787,2135,3261];
// SHOPLAZZA店铺id灰度列表
export const SMB_GRAY_SHOPLAZZA_LIST = [2438,1560,1543,1538,1843,1825,1537,1677,1586,1697,1961,2261,2226,1601,1815,2565,2605,1976,1962,2061,1540,1887,1988,1844,1888,1523,1542,1841,1539,1541,1680,1683,1826,1832,1914,1963,1965,2000,2824,2780,2758,3276,1842,1629,2094,1628,1590,1647,3052,2823,1276,2342,1327,1311,1063,1479,2585,3123,3128,3129,3130,2660,2577,2601,2737,2736,2663,2763,3249,2241,2905,3037,2546,2554,2555,2547,2690,2550,2788,2803,2851,2798,2819,2820,2869,3260,1228,2004,2566,2594,2595,3375,3500,3502,3505,3493,3497];
// 首批小灰度列表
export const SMB_GRAY_SMALL_LIST = [30, 3243, 2512, 2801, 2802];
//  SMB灰度合集
export const SMB_GRAY_LIST = [...SMB_GRAY_SMALL_LIST, ...SMB_GRAY_SHOPIFY_LIST, ...SMB_GRAY_SHOLINE_LIST, ...SMB_GRAY_SHOPLAZZA_LIST];

// 新功能试点灰度
export const isNewFunctionGray = () => {
  return SMB_GRAY_SMALL_LIST.includes(getCompanyInfo().id as number);
}
export const isEnableCustomStep = () => {
  return true;
};

export const isEnableFontPicker = () => {
  // 因为专项的代码已经推全smb了，包含了字体的功能了，所以这里直接返回true
  return true;
};

export const isEnableSmsCOICompany = () => {
  return [30, 3243, 2512, 2801, 2802, 2862, 2237, 2905, 1228, ...SMB_GRAY_LIST].includes(getCompanyInfo().id as number);  
}

export const isEnableFlowTfnSend = () => {
  return getCompanyInfo().tfnSendOpen === true && isEnableSmsCOICompany();
};

/** 是否启用广告图模版校验图片 */
export const isEnableAdImageTemplateCheck = () => {
  return ![30, 2283].includes(getCompanyInfo().id as number);
}

export const isEnableSmsDoubleCheck = () => {
  const { smsDoubleCheck, smsDoubleCheckScope } = getCompanyInfo();
  return smsDoubleCheck === true && (smsDoubleCheckScope === 'all' || smsDoubleCheckScope?.includes('form'));
};

/** 是否支持easy-mail */
export const isEnableEasyMailEditor = (): boolean => {
  return (getCompanyInfo().emailEditorStatus === 1 || getCompanyInfo().emailEditorStatus === 3);
};
